 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTACKNOWLDGMENTS from '@/components/Text/Acknowldgments'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTCHAP01 from '@/components/Text/Chap01'
 import TEXTCHAP02 from '@/components/Text/Chap02'
 import TEXTCHAP03 from '@/components/Text/Chap03'
 import TEXTCHAP04 from '@/components/Text/Chap04'
 import TEXTCHAP05 from '@/components/Text/Chap05'
 import TEXTCHAP06 from '@/components/Text/Chap06'
 import TEXTCHAP07 from '@/components/Text/Chap07'
 import TEXTCHAP08 from '@/components/Text/Chap08'
 import TEXTCHAP09 from '@/components/Text/Chap09'
 import TEXTCHAP10 from '@/components/Text/Chap10'
 import TEXTCHAP11 from '@/components/Text/Chap11'
 import TEXTCHAP12 from '@/components/Text/Chap12'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTNAMEINDEX from '@/components/Text/NameIndex'
 import TEXTSUBJECTINDEX from '@/components/Text/SubjectIndex'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTENDORSEMENTS from '@/components/Text/Endorsements'
 import TEXTMORETITLESFROMIVP from '@/components/Text/MoreTitlesfromIVP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Acknowldgments",
 			"name" : "Text/Acknowldgments",
 			"component" : TEXTACKNOWLDGMENTS
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/Chap01",
 			"name" : "Text/Chap01",
 			"component" : TEXTCHAP01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js